/**
 * Instance Axios partagée pour tous les appels à l'API générée (client OpenAPI).
 *
 * Centralise :
 *   - L'injection du Bearer token (JWT stocké en sessionStorage) à chaque requête
 *   - La gestion globale des erreurs 401 (token invalide / expiré)
 *
 * Utilisée par ChinookApiService pour instancier les API générées.
 */
import axios from 'axios';

const apiAxiosInstance = axios.create();

// ── Request : injection du token ─────────────────────────────────────────────
apiAxiosInstance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('id_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ── Response : passthrough (la gestion fine des 401 reste dans les services) ──
apiAxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default apiAxiosInstance;

